<template>
    <div class="rss-component" v-if="rssObj.channel">
      <div class="title">
      <span class="icon" v-if="false">
        <img class="icon" src="@/static/icon/gaba.png">
      </span>
      <span class="main-title">
        <el-link :href="rssObj.channel.link" target="_blank" :underline="false">
            {{rssObj.channel.title}}
        </el-link>
      </span>
      <span class="sub-title">
          （{{timeAgo(new Date(rssObj.channel.pubDate))}}）
      </span>
      </div>
      <div class="rss-list">
        <template v-for="(item, itemIndex) in rssObj.channel.items">
          <div class="item">
            <div class="item-index">
              {{(itemIndex + 1) + "."}}
            </div>
            <div class="item-content">
              <el-link :href="item.link" target="_blank" :underline="false">
              {{ item.title }}
              </el-link>
            </div>
            <div class="item-remark">
              {{getItemRemark(item)}}
            </div>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
import {getRSSList} from "@/api/rssApi";
import {formatDate, timeAgo} from "@/utils/DateUtil";

export default {
  name: "rssComponent",
  props: {
    rssObj: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      debugger
    },
    formatDate(date){
      return formatDate(date);
    },
    timeAgo(date){
      return timeAgo(date);
    },
    getItemRemark(item){
      let content = "";
      if(item.author){
        content = item.author;
      }else if(item.pubDate){
        content = formatDate(new Date(item.pubDate));
      }
      return content;
    }
  }
}
</script>

<style scoped>
.rss-component {
  width: 100%;
  height:500px;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

.title {
  display: flex;
  align-items: center;
  margin: 0;
  height: 10%;
}

.title .icon {
  width: 20px; /* 设置图标宽度为20px */
  height: 20px; /* 设置图标高度为20px */
  vertical-align: middle; /* 垂直居中对齐 */
  margin-left: 10px;
}
.title .main-title,.title .main-title a {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}
.title .sub-title {
  font-size: 12px;
}

.rss-list{
  width: 100%;
  height: 85%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.rss-list:hover {
  overflow-y: auto;
}

.item{
  text-align: justify;
  display: flex;
  margin: 10px 0 0px 20px;
}
.item-index{
  width: 15px;
  margin-right: 2%;
}
.item-content{
  width: 200px;
  font-size: 14px;
}
.item-remark{
  width: 100px;
  font-size: 12px;
  text-align: right;
  padding: 0 5px;
  color: #9f9f9f;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出的内容 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}

/* 滚动条优化 start */
::-webkit-scrollbar{
  width:6px;
  /*background-color: #fff;*/
}

::-webkit-scrollbar-track{
  background-color:transparent;
}
::-webkit-scrollbar-thumb {
  background: #B6B6B6FF;
  border-radius: 2px;
}
::-webkit-scrollbar-thumb:hover {
  background: #747474;
}
::-webkit-scrollbar-corner {
  background: #f6f6f6;
}
/* 滚动条优化 end */
</style>
